import Handlebars from 'handlebars';

class ImageViewerModalService {
	show(params) {
		// Create the handlebars template and transclude the params.body value. Assuming it has it
		let setModalTemplate = () => {
			let imageViewerModalBlockPartial = require('../../../views/blocks/imageViewerModalBlock/tmpl/imageViewerModalBlock.hbs');
			Handlebars.registerPartial('imageViewerModalBlock', imageViewerModalBlockPartial);

			let template = `
			{{#> imageViewerModalBlock
				blk="imageViewerModalBlock"
				ns="ImageViewerModalBlock"
			}}
				${!_.isNil(params) && !_.isNil(params.body) ? params.body : ''}
			{{/imageViewerModalBlock}}`;
			let precompiled = new Function('return ' + Handlebars.precompile(template))();
			this.itemTemplate = Handlebars.template(precompiled);
		};

		// Removes the modal element as we have closed it
		let removeModal = () => {
			this.$imageViewerModalElement.modal('dispose');
			$('#imageViewerModalBlock').remove();
		};

		// Shows the modal and give it a unique ID to target so that we can remove it when needed
		let showModal = () => {
			this.$imageViewerModalBlock = $('#imageViewerModalBlock');
			this.$imageViewerModalElement = this.$imageViewerModalBlock.children('.modal');
			this.$imageViewerModalElement.modal('show');
			$('.modal-backdrop').addClass('modal-backdrop--black');
			this.$imageViewerModalElement.on('hidden.bs.modal', () => {
				removeModal();
			});
		};

		setModalTemplate();

		// Pass in the title param
		let markupParams = {};
		if(!_.isNil(params) && !_.isNil(params.title)) {
			markupParams['title'] = params.title;
		}
		let markup = this.itemTemplate(markupParams);
		// Render the markyp
		$(document.body).append(markup);
		showModal();
	}
}

export let imageViewerModalService = new ImageViewerModalService();
